// @copyright  2006 - 2024 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'asset.page.title': 'Fixed Assets',
    'asset.page.dispose.title': 'Disposed Assets',
    'asset.page.sold.title': 'Sold Assets',
    'asset.page.retire.title': 'Retired Assets',
    'asset.page.search_results': 'Search Results',
    'asset.page.create.title': 'Create New Asset',
    'asset.page.search.title': 'Find Assets',
    'asset.page.edit.title': 'Edit Asset',
    'asset.page.view.title': 'View Asset',
    'asset.page.view.title.sell': 'Sell Asset',
    'asset.page.view.title.dispose': 'Dispose Asset',
    'asset.page.view.title.revalue': 'Revalue Asset',
    'asset.page.all': 'All',

    'asset.button.cancel': 'Cancel',
    'asset.button.select': 'Select',
    'asset.button.find': 'Find Assets',
    'asset.button.search': 'Apply',
    'asset.button.create': 'Create Asset',
    'asset.button.new': 'New Asset',
    'asset.button.save': 'Save Changes',
    'asset.button.dispose': 'Dispose Asset',
    'asset.button.sold': 'Sell Asset',
    'asset.button.retire': 'Retire Asset',
    'asset.button.draft': 'Save Draft',
    'asset.button.edit': 'Edit',
    'asset.button.restore': 'Restore',
    'asset.button.reset': 'Reset',
    'asset.button.depreciate': 'Depreciate',
    'asset.button.revalue': 'Revalue',
    'asset.button.claim_allowance': 'Claim Allowance',

    'asset.placeholder.search': 'Search assets',

    'asset.link.create_first_asset': 'Click here to create your first asset',
    'asset.link.assets': ' Return to Assets',
    'asset.link.dispose': 'Disposed Assets',
    'asset.link.sold': 'Sold Assets',
    'asset.link.retire': 'Retired Assets',
    'asset.link.allowance_claim': 'Allowance Claims',
    'asset.link.depreciation_schedule': 'Depreciation Schedule',
    'asset.link.retry': 'Click here to retry',

    'asset.message.search.no_sold_assets': 'No assets sold',
    'asset.message.search.no_disposed_assets': 'No assets disposed',
    'asset.message.search.no_retired_assets': 'No assets retired',

    'asset.checkbox.all': 'Check All',
    'asset.checkbox.actions_label': 'with selected',

    'asset.label.vendor_entity_name': 'Vendor',
    'asset.label.general_ledger_account_name': 'General Ledger Account',
    'asset.label.expense_name': 'Expense',
    'asset.label.asset_number': 'Asset Number',
    'asset.label.asset_type_name': 'Asset Type',
    'asset.label.asset_allowance_type_name': 'Allowance Type',
    'asset.label.asset_depreciation_method_name': 'Depreciation Method',
    'asset.label.depreciation_period': 'Depreciation Period',
    'asset.label.asset_name': 'Asset Name',
    'asset.label.description': 'Description',
    'asset.label.notes': 'Notes',
    'asset.label.make': 'Make',
    'asset.label.model': 'Model',
    'asset.label.model_no': 'Model No',
    'asset.label.serial_number': 'Serial Number',
    'asset.label.purchase_at': 'Purchase At',
    'asset.label.sold_at': 'Sold At',
    'asset.label.retired_at': 'Retired At',
    'asset.label.disposed_at': 'Disposed At',
    'asset.label.last_revalued_at': 'Revalued At',
    'asset.label.purchase_currency_name': 'Purchase Currency',
    'asset.label.currency_purchase_cost_in_cents': 'Purchase Cost',
    'asset.label.sale_currency_name': 'Sale Currency',
    'asset.label.currency_sale_price_in_cents': 'Sale Price',
    'asset.label.currency_current_value_in_cents': 'Current Value',
    'asset.label.base_current_value_in_cents': 'Current Value',
    'asset.label.annual_depreciation_amount': 'Annual Depreciation Amount',
    'asset.label.annual_percentage_depreciation': 'Annual Percentage Depreciation',
    'asset.label.bank_general_ledger_account_name': 'Bank Account',
    'asset.label.transaction_type': 'Transaction Type',
    'asset.label.new_purchase': 'Record new purchase',
    'asset.label.existing_asset': 'Add existing asset',
    'asset.label.last_depreciated_at': 'Last Depreciation Date',

    'asset.label.status': 'Status',

    'asset.sort.field_label': 'Field',
    'asset.sort.direction_label': 'Direction',
    'asset.sort.direction_ascending': 'Ascending',
    'asset.sort.direction_descending': 'Descending',

    'asset.modal.title.asset_dispose': 'Dispose Asset',
    'asset.modal.title.asset_sold': 'Sold Asset',
    'asset.modal.title.asset_retire': 'Retire Asset',
    'asset.modal.title.asset_delete_permanently': 'Delete Asset',
    'asset.modal.title.asset_restore': 'Restore Asset',
    'asset.modal.title.asset_depreciate': 'Depreciate Asset',
    'asset.modal.title.asset_allowance_claim': 'Claim Asset Allowance',

    'asset.modal.message.asset_dispose': 'Are you sure that you want to move this asset to the dispose? | Are you sure that you want to move these assets to the dispose?',
    'asset.modal.message.asset_retire': 'Are you sure that you want to move this asset to the retire? | Are you sure that you want to move these assets to the retire?',
    'asset.modal.message.asset_delete_permanently': 'Are you sure that you want to permanently delete this asset? This action cannot be undone. | Are you sure that you want to permanently delete these assets? This action cannot be undone.',
    'asset.modal.message.asset_restore': 'Are you sure that you want to restore this asset? | Are you sure that you want to restore these assets?',
    'asset.modal.message.asset_bring_current': 'Should we calculate depreciation for the next period or update the accumulated depreciation to reflect the current period?',
    'asset.modal.message.asset_allowance_claim': 'Should we calculate allowance for the next period or update to reflect the current period?',

    'asset.success.message.asset_created': 'Your asset has been created',
    'asset.success.message.asset_updated': 'Your asset has been updated',
    'asset.success.message.asset_depreciated': 'Your asset has been depreciated',
    'asset.success.message.asset_deleted': 'Your asset has been permanently deleted | All selected assets were permanently deleted',
    'asset.success.message.asset_disposed': 'Your asset has been disposed.',
    'asset.success.message.asset_sold': 'Your asset was marked sold.',
    'asset.success.message.asset_retired': 'Your asset has been retired.',
    'asset.success.message.asset_revalued': 'Your asset has been revalued.',
    'asset.success.message.asset_allowance_claimed': 'Your asset allowance has been claimed.',

    'asset.error.message.asset_current': "Asset's depreciation is up to date",
    'asset.error.message.asset_not_due_yet': "This asset isn't due for depreciation yet — the first eligible period has not ended.",
    'asset.error.message.asset_allowance_current': "Asset's capital allowance claims are up to date",
    'asset.error.message.asset_allowance_not_due_yet': "This asset isn't due for a capital allowance claim yet — the purchase tax year has not ended.",
    'asset.error.message.asset_allowance_no_rate_for_purchase_date': 'No capital allowance rate was in force when this asset was purchased, so no claim can be made.',
    'asset.error.message.asset_disposed': 'This asset was already disposed.',
    'asset.error.message.asset_sold': 'This asset was already moved to the sold | These assets were already moved to the sold',
    'asset.error.message.asset_retired': 'This asset was already retired.',
    'asset.error.message.asset_deleted': 'This asset was already permanently deleted | These assets were already permanently deleted',
    'asset.error.message.asset_restored': 'This asset was already restored | These assets were already restored',
    'asset.error.message.error_loading_page': 'Sorry, there was an error loading asset.| Sorry, there was an error loading assets.',

    'asset.message.search.no_asset_disposed': "You don't have any disposed assets.",
    'asset.message.search.no_asset_sold': "You don't have any sold assets.",
    'asset.message.search.no_asset_retired': "You don't have any retired assets.",
};
